<template>
  <div>
    <div class="top">
      <div class="title">
        <span></span>
        <p>管理员</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
</style>